import React from 'react';

import { CardContractSummaryCard } from '../components/CardContractSummaryCard';
import { CardContractTilesGrid } from '../components/CardContractTilesGrid';
import { ContractView } from '../ContractTab';

type CardContractOverviewProps = {
  contractId: string;
  contractIds: string[];
  contractAuxIds?: Record<string, number>;
  loading: boolean;
  contractDetails: any;
  onNavigate: (view: ContractView) => void;
  onContractChange: (id: string) => void;
};

export function CardContractOverview({
  contractId,
  contractIds,
  contractAuxIds,
  loading,
  contractDetails,
  onNavigate,
  onContractChange,
}: CardContractOverviewProps) {
  return (
    <div>
      <CardContractSummaryCard
        contractId={contractId}
        contractIds={contractIds}
        contractAuxIds={contractAuxIds}
        loading={loading}
        contractDetails={contractDetails}
        onContractChange={onContractChange}
        onMoreDetails={() => onNavigate('details')}
      />
      <CardContractTilesGrid loading={loading} onNavigate={onNavigate} />
    </div>
  );
}
